<template>
  <transition name="fade">
    <div class="container">
      <h1>Profil</h1>
      <ProfileInfo
        :user="localuser"
        :beers="beers"
        v-on:update-user="updateUser">
      </ProfileInfo>
      <Beer v-for="drinkedBeer in localuser.drinkedBeers" :key="drinkedBeer.id"
        :beer="drinkedBeer"
      ></Beer>

    </div>
  </transition>
</template>

<script>
import axios from 'axios'

import ProfileInfo from '../components/ProfileInfo.vue';
import Beer from '../components/Beer.vue';

export default {
  name: 'Profil',
  props: {
    beers: Array,
    user: Object
  },
  data: function() {
    return {
      localuser:  JSON.parse(JSON.stringify(this.user))
    }
  },
  components: {
    ProfileInfo,
    Beer
  },
  methods: {
    updateUser: function(user) {
      console.log(this.user.id);
      this.localuser.id = user;
      console.log(this.user.id);
      axios.get('https://klogtkryds.dk/studenterbaren/api/drinkedBeers/'+user)
        .then(res => this.localuser.drinkedBeers = res.data.data)
        .catch( () => {this.localuser.drinkedBeers = []});
    },
  }

}
</script>
